import React from 'react';

function LeftSection({ daysOfWeek, onDayClick, currentDay }) {
  // Ensure that daysOfWeek exists before mapping
  if (!daysOfWeek || daysOfWeek.length === 0) {
    return null; // Render a fallback message if no days are provided
  }

  return (
    <div className="left-section">
      <h4>Words this week</h4>
      <ul className="week-list">
        {daysOfWeek.map((day, index) => (
          <li
            key={index}
            className={`day-item ${index === currentDay ? 'active' : ''}`} // Highlight the current day
            onClick={() => onDayClick(index)} // Trigger day change on click
          >
            {day}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default LeftSection;
